// extracted by mini-css-extract-plugin
module.exports = {"cardNumber":"styles_cardNumber__Mls57","body":"styles_body__1UZwx"};